import { Reducer } from 'react';
import { IApplicantQuestion } from '../EditJob/types';
import { SmartFormsAction, SmartFormsState } from './types';

export const InitialSmartFormsState: SmartFormsState = {
  currentPage: Number(sessionStorage.getItem(`smartFormsTablePage`)) || 1,
  rowsPerPage: 10,
  sortBy: 'name',
  sortOrder: 'asc',
  search: '',
  snackbar: {
    message: '',
    state: 'success'
  },
  isDialogOpen: false,
  deleteSmartForm: 0,
  showSmartFormModal: null,
  enabled: true,
  selectedEntity: 0,
  name: '',
  selectedForm: null
};

export const SmartFormsReducer: Reducer<SmartFormsState, SmartFormsAction> = (
  state: SmartFormsState,
  action: SmartFormsAction
) => {
  switch (action.type) {
    case 'SET_CURRENT_PAGE':
      return { ...state, currentPage: action.payload };
    case 'SET_ROWS_PER_PAGE':
      return { ...state, rowsPerPage: action.payload };
    case 'SET_SORT_BY':
      return { ...state, sortBy: action.payload };
    case 'SET_SORT_ORDER':
      return { ...state, sortOrder: action.payload };
    case 'SET_SEARCH':
      return { ...state, search: action.payload };
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_IS_DIALOG_OPEN':
      return { ...state, isDialogOpen: action.payload };
    case 'SET_DELETE_SMART_FORM':
      return { ...state, deleteSmartForm: action.payload };
    case 'SET_MODAL_OPEN':
      return {
        ...state,
        showSmartFormModal: action.payload
      };
    case 'SET_TOGGLE_ENABLED':
      return { ...state, enabled: !state.enabled };
    case 'SET_SELECTED_ENTITY':
      return { ...state, selectedEntity: action.payload };
    case 'SET_NAME':
      return { ...state, name: action.payload };
    case 'SET_SELECTED_FORM':
      return { ...state, selectedForm: action.payload };
    case 'RESET_SMART_FORM':
      return {
        ...state,
        name: InitialSmartFormsState.name,
        enabled: InitialSmartFormsState.enabled
      };
  }
};

export interface SmartFormFieldsState {
  snackbar: {
    message: string;
    state: 'success' | 'warning' | 'error';
  };
  modalsOpen: {
    newField: boolean;
    addSystemField: boolean;
    importFields: boolean;
    smartFormSettings: boolean;
  };
  editingQuestion: IApplicantQuestion | null;
  selectedSystemField: string | null;
  selectedSourceId: string | null;
  systemFieldError: string;
  actionStates: Record<number, Record<string, boolean>>;
}

export const InitialSmartFormFieldsState: SmartFormFieldsState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  modalsOpen: {
    newField: false,
    addSystemField: false,
    importFields: false,
    smartFormSettings: false
  },
  editingQuestion: null,
  selectedSystemField: null,
  selectedSourceId: null,
  systemFieldError: '',
  actionStates: {}
};

export type SmartFormFieldsAction =
  | { type: 'SET_SNACKBAR'; payload: { message: string; state: 'success' | 'warning' | 'error' } }
  | {
      type: 'SET_MODALS_OPEN';
      payload: {
        newField: boolean;
        addSystemField: boolean;
        smartFormSettings: boolean;
        importFields: boolean;
      };
    }
  | { type: 'SET_EDITING_QUESTION'; payload: IApplicantQuestion | null }
  | { type: 'SET_SELECTED_SYSTEM_FIELD'; payload: string | null }
  | { type: 'SET_SELECTED_SOURCE_ID'; payload: string | null }
  | { type: 'SET_SYSTEM_FIELD_ERROR'; payload: string }
  | { type: 'SET_ACTION_STATES'; payload: Record<number, Record<string, boolean>> };

export const SmartFormFieldsReducer: Reducer<SmartFormFieldsState, SmartFormFieldsAction> = (
  state: SmartFormFieldsState,
  action: SmartFormFieldsAction
) => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_MODALS_OPEN':
      return { ...state, modalsOpen: action.payload };
    case 'SET_EDITING_QUESTION':
      return { ...state, editingQuestion: action.payload };
    case 'SET_SELECTED_SYSTEM_FIELD':
      return { ...state, selectedSystemField: action.payload };
    case 'SET_SELECTED_SOURCE_ID':
      return { ...state, selectedSourceId: action.payload };
    case 'SET_SYSTEM_FIELD_ERROR':
      return { ...state, systemFieldError: action.payload };
    case 'SET_ACTION_STATES':
      return { ...state, actionStates: action.payload };
  }
};
